import { useQuery } from '@apollo/client';
import type { AuthProvider } from '@communities/community/domain';
import { GET_AUTH_PROVIDERS } from '@communities/community/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface AuthProvidersResponse {
  authProviders: {
    providers: AuthProvider[];
    isAdmin: boolean;
  };
}

export function useAuthProviders() {
  const { data, loading, error, refetch } = useQuery<AuthProvidersResponse>(GET_AUTH_PROVIDERS, {
    fetchPolicy: 'cache-first',
  });

  const providers = useMemo(() => data?.authProviders?.providers || [], [data]);

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    providers,
    loading,
    errors,
    refetch,
  };
}

export default useAuthProviders;
